// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "c55d4105763b15850c86c04fb23f8c5fd313a481/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"21":"2a222798","98":"c3469f9b","215":"28b12c6b","440":"2a9a7941","496":"89e6df15","581":"04bc5b3b","731":"93042797"}[chunkId] + ".chunk.js";
};